import { Permissions } from "@/type/api";
import { MODULE_KEYS, PAGE_KEYS } from "./keys";
import type { AppModuleDefinition } from "./types";

export const coreModules: AppModuleDefinition[] = [
  {
    key: MODULE_KEYS.DESK,
    label: "Desk",
    labelKey: "alkokh.sidebar.profile",
    icon: "tabler-smart-home",
    fallbackRoles: [Permissions.DeskUser],
    nav: {
      order: 10,
      titleKey: "alkokh.sidebar.profile",
      icon: "tabler-smart-home",
      singlePage: true,
      // Home is always the first tab when the user can reach it.
      mobileOrder: 10,
    },
    pages: [
      {
        key: PAGE_KEYS.ROOT,
        label: "Profile",
        labelKey: "alkokh.sidebar.profile",
        doctype: "User",
        paths: ["/", "/profile"],
        routeNames: ["root", "profile"],
        fallbackRoles: [Permissions.DeskUser],
        nav: {
          titleKey: "alkokh.sidebar.profile",
          icon: "tabler-user",
          order: 10,
          to: { path: "/profile" },
        },
      },
    ],
  },
  {
    key: MODULE_KEYS.MODULES,
    label: "Module Launcher",
    labelKey: "alkokh.sidebar.modules",
    icon: "tabler-layout-grid",
    fallbackRoles: [Permissions.DeskUser],
    nav: {
      order: 20,
      titleKey: "alkokh.sidebar.modules",
      icon: "tabler-layout-grid",
    },
    pages: [],
  },
  {
    key: MODULE_KEYS.HRMS,
    label: "HRMS",
    labelKey: "alkokh.sidebar.hrms",
    icon: "tabler-users",
    fallbackRoles: [Permissions.DeskUser, Permissions.HRUser, Permissions.HRManager],
    pages: [
      {
        key: PAGE_KEYS.HRMS,
        label: "HRMS",
        labelKey: "alkokh.sidebar.hrms",
        doctype: "Employee",
        paths: ["/hrms"],
        pathPrefixes: ["/hrms/"],
        fallbackRoles: [Permissions.DeskUser, Permissions.HRUser, Permissions.HRManager],
        nav: {
          titleKey: "alkokh.sidebar.hrms",
          icon: "tabler-users",
          order: 20,
          parentModuleKey: MODULE_KEYS.MODULES,
          to: { path: "/hrms" },
        },
      },
    ],
  },
  {
    key: MODULE_KEYS.HIS,
    label: "HIS",
    labelKey: "alkokh.sidebar.his",
    icon: "tabler-heartbeat",
    fallbackRoles: [
      Permissions.DeskUser,
      Permissions.Visit,
      Permissions.HealthcareAdministrator,
      Permissions.Physician,
      Permissions.LaboratoryUser,
      Permissions.NursingUser,
    ],
    pages: [
      {
        key: PAGE_KEYS.HIS,
        label: "HIS",
        labelKey: "alkokh.sidebar.his",
        doctype: "Patient",
        paths: ["/his"],
        pathPrefixes: ["/his/"],
        fallbackRoles: [
          Permissions.DeskUser,
          Permissions.Visit,
          Permissions.HealthcareAdministrator,
          Permissions.Physician,
          Permissions.LaboratoryUser,
          Permissions.NursingUser,
        ],
        nav: {
          titleKey: "alkokh.sidebar.his",
          icon: "tabler-building-hospital",
          order: 30,
          parentModuleKey: MODULE_KEYS.MODULES,
          to: { path: "/his" },
        },
      },
    ],
  },
  {
    key: MODULE_KEYS.CORRESPONDENCE,
    label: "Correspondence",
    labelKey: "alkokh.sidebar.correspondence",
    icon: "tabler-inbox",
    fallbackRoles: [Permissions.DeskUser, Permissions.InboxUser],
    pages: [
      {
        key: PAGE_KEYS.CORRESPONDENCE,
        label: "Correspondence",
        labelKey: "alkokh.sidebar.correspondence",
        doctype: "Communication",
        paths: ["/correspondence"],
        pathPrefixes: ["/correspondence/"],
        fallbackRoles: [Permissions.DeskUser, Permissions.InboxUser],
        nav: {
          titleKey: "alkokh.sidebar.correspondence",
          icon: "tabler-mail",
          order: 40,
          parentModuleKey: MODULE_KEYS.MODULES,
          to: { path: "/correspondence" },
        },
      },
    ],
  },
  {
    key: MODULE_KEYS.PET,
    label: "Pet Profiles",
    labelKey: "alkokh.sidebar.pet",
    icon: "tabler-paw",
    fallbackRoles: [Permissions.Pet],
    nav: {
      order: 40,
      titleKey: "alkokh.sidebar.pet",
      icon: "tabler-paw",
      singlePage: true,
      // Pets outrank the back-office modules that sit between them in `order`.
      mobileOrder: 30,
    },
    pages: [
      {
        key: PAGE_KEYS.PET_PROFILE,
        label: "Pet Profiles",
        labelKey: "alkokh.sidebar.pet",
        doctype: "Pet",
        paths: ["/pet-profile/list"],
        pathPrefixes: ["/pet-profile/"],
        routeNames: ["pet-profile-list"],
        fallbackRoles: [Permissions.Pet],
        nav: {
          titleKey: "alkokh.sidebar.pet",
          icon: "tabler-paw",
          order: 10,
          to: { name: "pet-profile-list" },
        },
      },
    ],
    search: [
      {
        group: "Records",
        icon: "tabler-paw",
        title: "Pets",
        url: { name: "pet-profile-list" },
        accessKey: PAGE_KEYS.PET_PROFILE,
        order: 10,
        noData: true,
      },
    ],
  },
];
